<template>
    <div class="m-addImageByManual">
        <div v-if="!paperData.length" class="manual-no-topic">
            <p>{{$t('paper.clickBtnAddTopic')}}</p>
            <div class="btn-group">
                <el-button type="primary" @click="dialogOpen">{{$t('paper.addTopic')}}</el-button>
            </div>
        </div>

        <div v-if="paperData.length" class="paper-container">
            <aside class="paper-aside">
                <sticky :stickyTop="130" scroller=".sub-page .el-main">
                    <div class="paper-aside-wrap">
                        <div class="paper-aside-box category">
                            <p>{{$t('paper.imageTopic')}}：{{paperData.length}} {{$t('paper.dao')}}</p>
                            <p>{{$t('paper.eachTopic')}}：
                                <el-input-number
                                    v-model="topicScore" size="mini" :min="1" :max="50"></el-input-number>
                                {{$t('paper.points')}}
                            </p>
                        </div>
                        <div class="paper-aside-box total">
                            <p>{{$t('paper.totalQuestions')}}：{{paperData.length}}</p>
                            <p>{{$t('paper.totalScores')}}：{{(paperData.length * topicScore).toFixed(2)}}
                                {{$t('paper.points')}}</p>
                            <p>{{$t('paper.passScore')}}：{{(paperData.length * topicScore * passLine).toFixed(2)}}
                                {{$t('paper.points')}}</p>
                        </div>
                        <div class="btn-group btn-aside">
                            <el-button class="btn-other" @click="dialogOpen" type="primary" plain>
                                <i class="nucfont inuc-add-circle"></i>{{$t('paper.addTopic')}}
                            </el-button>
                            <el-button class="btn-other" @click="previewPaper" type="primary" plain>
                                <i class="nucfont inuc-preview"></i>{{$t('paper.previewPaper')}}
                            </el-button>
                            <el-button type="primary"
                                       class="btn-submit"
                                       @click="submitPaper"
                                       :loading="submitLoading"
                                       :disabled="!paperData.length">
                                <i class="nucfont inuc-step-right"></i>
                                {{$t('paper.savePaper')}}
                            </el-button>
                        </div>
                    </div>
                </sticky>
            </aside>
            <ul class="paper-list">
                <li v-for="(item, index) in paperData" :key="item.id" class="item">
                    <div class="image-wrap">
                        <img v-if="item.luggage" :src="item.luggage.thumbnails[0].url">
                        <img v-else :src="item.thumbnails[0].url">
                    </div>
                    <div class="image-des">

                        <div class="image-basic-info">
                            <div class="basic-top">
                                <p class="image-type">【<span class="type-name">{{item.typeName}}</span> , <span
                                    class="type-name">{{item.number}}</span>】</p>
                                <p>{{$t('c.knowledgePoint')}}：{{item.knowledgeName}}</p>
                                <p>{{$t('c.operatorLevel')}}：{{item.forLevelName}}</p>
                                <p>{{$t('c.difficulty')}}：{{item.difficultyName}}</p>
                                <p>{{$t('topic.papersAssembled')}}：{{item.usageCount}}</p>
                                <p>{{$t('paper.accuracyRate')}}：{{item.accuracy!=-1?(Math.round(item.accuracy * 10000) /
                                    100 + '%'):'--'}}</p>
                            </div>

                            <div class="btn-operate">
                                <a class="btn-edit" @click="setKey(index)" :title="$t('paper.setKeyTopic')">
                                    <i class="nucfont inuc-key-topic" :class="{'is-key': item.key}"></i>
                                </a>
                                <a class="btn-edit"
                                   v-if="trainerID === item.creatorID"
                                   @click="editTopic(item, index)" :title="$t('paper.editPaper')">
                                    <i class="nucfont inuc-edit"></i>
                                </a>
                                <el-popconfirm :title="$t('m.delete')" @confirm="deleteTopic(index)">
                                    <a class="btn-delete" :title="$t('c.delete')" slot="reference">
                                        <i class="nucfont inuc-delete"></i>
                                    </a>
                                </el-popconfirm>
                            </div>

                        </div>
                        <div class="image-answer">
                            <p class="des-block">
                                <span class="des-title">{{$t('topic.imageDesc')}}：</span>
                                <span class="des-content">{{ (item.luggage && item.luggage.description) || $t('c.none')}}</span>
                            </p>

                            <p class="des-block"><span class="des-title">{{$t('topic.answerAnalysis')}}：</span><span
                                class="des-content" v-html="item.analysisRT||$t('c.none')"></span></p>
                        </div>
                    </div>

                </li>
            </ul>
        </div>

        <el-backtop target=".sub-page .el-main"></el-backtop>

        <topic-dialog
            v-if="true"
            v-model="topicSelector"
            :paperType="type"
            :init-ids="paperDataIds"
            :disableChecked="true"
            @on-save="addTopicDone"
        ></topic-dialog>

        <!-- 图像全屏查看 -->
        <full-screen
            ref="nstswrap"
            :src="src"
            :isShow="isShow"
            :showCloseBtn="false"
            @changeIsShow="toggleIsShow"
        />

        <!-- 图像编辑页 -->
        <transition enter-active-class="animated slideInRight"
                    leave-active-class="animated slideOutRight">
            <router-view @onSave="editTopicSuccess">
            </router-view>
        </transition>
    </div>
</template>

<script>
    import api from '@/api'
    import FullScreen from '@/components/FullScreen'
    import {mapGetters} from 'vuex'
    import selectMultiKnowledge from '@/components/SelectMultiKnowledge'
    import selectMultiple from '@/components/Selectmultiple'
    import TopicDialog from "@/components/Dialog/TopicDialog"
    import {Ticket} from '@/utils'
    import sticky from '@/components/Sticky'

    export default {
        props: ['passLine', 'paperName', 'pattern', 'type', 'knowledgeName', 'forLevel', 'difficulty', 'paperDetail', 'paperId', 'score'],
        components: {
            selectMultiple,
            selectMultiKnowledge,
            FullScreen,
            sticky,
            TopicDialog
        },
        data() {
            return {
                isShow: false,
                src: '',
                paperData: [],
                dialog: {
                    type: 3,
                    topicDialog: false,
                    initData: []
                },
                topicScore: 2,
                submitLoading: false,
                options: [{
                    value: false,
                    label: this.$t('topic.examPaperLibrary')
                }, {
                    value: true,
                    label: this.$t('topic.myTopic')
                }],
                formSearch: {
                    number: '',
                    title: '',
                    forLevels: [],
                    difficulties: [],
                    types: [],
                    isOnlyMine: true,
                    knowledges: [0],
                },
                selectNames: [
                    {
                        key: "forLevel",
                    }, {
                        key: "difficulty",
                    },],
                tableProps: {
                    border: false,
                    stripe: true,
                    rowKey: row => row.id,
                    height: "55vh"
                },
                currentPage: 1,
                pageSize: 20,
                sortName: '',
                order: '',
                dialogTableData: [],
                dialogTableLength: 0,
                dialogTableloading:false,
                gridData: [],
                dialogTableVisible: false,

                topicSelector: false
            }
        },
        created() {
            if (this.paperDetail.length > 0) {
                this.paperDetail.forEach(item => {
                    item.topic.key = item.key
                    this.paperData.push(item.topic)
                })
                this.paperData.forEach(item => {
                    if (item.accuracy == null) {
                        item.accuracy = -1
                    }
                })
                this.topicScore = this.score
            }
        },
        mounted() {
        },
        computed: {
            dialogName() {
                let txt
                this.type == 3 ? txt = 'CT' : txt = 'DR'
                return txt
            },
            ...mapGetters([
                'knowledgeList',
            ]),
            trainerID() {
                return Ticket.get().userID
            },
            paperDataIds() {
                if (this.paperData.length) {
                    return this.paperData.map(item => item.id)
                }
                return []
            },
        },
        methods: {
            dialogOpen() {
                this.topicSelector = true
            },
            addTopicDone(ids, data) {
                let newData = data.filter(item => !this.paperDataIds.includes(item.id))
                this.paperData = this.paperData.concat(newData)
                console.log(newData)
            },

            lastStep() {
                this.$emit('last-step')
            },

            //提交考卷
            submitPaper() {
                let submitData = {
                    form: this.pattern,
                    type: this.type,
                    passLine: this.passLine,
                    title: this.paperName,
                    knowledge: this.knowledgeName[this.knowledgeName.length - 1],
                    forLevel: this.forLevel,
                    difficulty: this.difficulty,
                    totalScore: this.paperData.length * this.topicScore,
                    relationship: []
                }
                this.submitLoading = true
                // 题目的拼装
                this.paperData.forEach(val => {
                    let info = {}
                    info.topicID = val.id
                    info.score = this.topicScore
                    info.key = val.key
                    submitData.relationship.push(info)
                })
                let msg
                this.type == 3 ? msg = 'CT' : msg = 'DR'
                if (this.paperId) {
                    api.putPaper(this.paperId, submitData).then(res => {
                        this.submitLoading = false
                        this.$notify.success({
                            title: res.error,
                            message: msg + this.$t('paper.editPaperSuccess'),
                            type: 'success',
                            duration: 2000
                        })
                        this.$emit('needUpdate')
                        this.$router.replace({name: 'myPaper'})
                    }).catch(error => this.submitLoading = false)
                } else {
                    api.postPaper(submitData).then(res => {
                        this.submitLoading = false
                        this.$notify.success({
                            title: res.error,
                            message: msg + this.$t('paper.imagePaperMakeSuccess'),
                            type: 'success',
                            duration: 2000
                        })
                        this.$emit('needUpdate')
                        this.$router.replace({name: 'myPaper'})
                    }).catch(error => this.submitLoading = false)
                }
            },

            editTopic(item, index) {
                if (this.paperId) {
                    name = this.type === 3 ? 'editImagePaperEditCT' : 'editImagePaperEditDR'
                } else {
                    name = this.type === 3 ? 'addImagePaperEditCT' : 'addImagePaperEditDR'
                }
                this.$router.push({name, params: {topicID: item.id, topicIndex: index}})
            },
            editTopicSuccess(data, index) {
                Object.assign(this.paperData[index], data)
            },

            deleteTopic(index) {
                this.paperData.splice(index, 1)
            },
            //考卷预览
            previewPaper() {
                let previewIDs = this.paperData.map(item => item.id).join('-')
                this.isShow = !this.isShow
                if (this.type === 3) {
                    this.src = `${api.imagePanoramicHost}/ctPaperPreview?topicIds=${previewIDs}&lang=${this.$i18n.locale}`
                    // this.src = `/static/3D/CT_base.html?type=PAPER_PREVIEW&paperID=${previewIDs}&isMaking=1`
                } else {
                    this.src = `${api.imagePanoramicHost}/drPaperPreview?topicIds=${previewIDs}&lang=${this.$i18n.locale}`
                    // this.src = `/static/3D/DR_base.html?type=PAPER_PREVIEW&paperID=${previewIDs}&isMaking=1`
                }
                this.$refs.nstswrap.fullScreen()
            },
            // 图像考卷预览
            toggleIsShow(val) {
                this.isShow = val
                this.src = null
            },


            getForLevelVal(data) {
                this.formSearch.forLevels = data
            },
            getDifficultyVal(data) {
                this.formSearch.difficulties = data
            },
            knowledgeChange(data) {
                this.formSearch.knowledges = data
            },
            setKey(index) {
                this.paperData[index].key = !this.paperData[index].key
                this.$set(this.paperData, index, this.paperData[index])
            },
            // 获取row的key值
            getRowKeys(row) {
                return row.id
            },
            toTop() {
                this.$scrollElement.animate({scrollTop: 0}, 500)
            }
        },
    }
</script>

<style lang="scss">
    @import '../../../style/const';

    .m-addImageByManual {
        .paper-list {
            > li {
                margin-bottom: 20px;
                padding: 5px 20px 5px 5px;
                font-size: 12px;
                background-color: #f3f8ff;
                border-radius: 8px;
                display: flex;
                justify-content: space-between;

                .image-wrap {
                    width: 320px;
                    height: 233px;
                    margin-right: 20px;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    background-color: #fff;

                    img {
                        max-height: 100%;
                    }
                }

                .image-des {
                    width: 60%;

                    .image-basic-info {
                        display: flex;
                        justify-content: space-between;
                        padding-top: 10px;
                        padding-bottom: 5px;

                        p {
                            margin-bottom: 8px;
                        }

                        .image-type {
                            margin-left: -5px;

                            .type-name {
                                padding: 2px;
                                color: #ff4081;
                            }
                        }
                    }

                    .image-answer {
                        padding-top: 10px;
                        padding-bottom: 5px;
                        border-top: dashed 1px #d8d8d8;

                        .des-block {
                            margin-bottom: 8px;
                            white-space: nowrap;

                            .des-title {
                                color: #2e7faa;
                            }

                            .des-content {
                                white-space: normal;
                            }
                        }
                    }
                }

                .btn-operate {
                    a {
                        display: inline-block;
                        margin-right: 9px;
                        cursor: pointer;
                        color: #999;

                        .nucfont {
                            font-size: 18px;
                        }

                        &.btn-edit:hover {
                            color: $color-theme;
                        }

                        &.btn-delete:hover {
                            color: $c-danger;
                        }

                        &.btn-edit {
                            .is-key {
                                color: $blue;
                                font-weight: 600;
                            }
                        }
                    }
                }
            }

            .detail {
                dt {
                    margin-bottom: 10px;
                    font-weight: 600;
                    color: #333;
                    font-size: 14px;
                }

                dd {
                    display: flex;
                    margin-left: 5px;
                    margin-bottom: 10px;

                    em {
                        line-height: 1.5;
                        font-style: normal;
                    }

                    p {
                        line-height: 1.5;
                        margin-left: 3px;
                    }

                    &.rightAnswer {
                        color: #1A8CFE;
                        font-weight: 600;
                    }
                }

                .choice-topic {
                    em {
                        &.rightAnswer {
                            color: #1A8CFE;
                            font-weight: 600;
                        }

                        &:last-child {
                            margin-left: 30px;
                        }
                    }
                }
            }

            .answer {
                margin-bottom: 10px;
            }

            .analysis {
                margin-bottom: 10px;
            }
        }

        .btn-group {
            text-align: center;
        }

        .el-table td div:first-child {
            cursor: pointer;
        }

    }

</style>
